export default __webpack_public_path__ + "static/tintash-logo-3137e4f23ea41c6689546725b90f8811.svg";